import * as hs from "@hlibs/react/hstyles"; 

const defaultProps = {
    color: null,
    size: null
};

const Text = (props = defaultProps) =>
{
    const mergedProps = hs.mergeProps(defaultProps, props);

    const styles = mergedProps.style ? hs.mergeStyles(mergedProps.style) : {};

    if(mergedProps.color) styles.color = mergedProps.color;
    if(mergedProps.size) styles.fontSize = mergedProps.size;

    return (
        <span {...mergedProps} style={styles}/>
    )
};

export default Text;